import Empty from "components/Empty"
import Spinner from "components/Spinner/FullScreen"
import React, { useEffect, useState } from "react"
import { FiArrowLeft, FiUser } from "react-icons/fi"
import { useNavigate, useParams } from "react-router-dom"
import works from "services/works"
import { DescriptionWork } from "./style"
import VideoPlayerBack from "components/VideoPlayBack"
import { useHideModal, useShowModal } from "hooks"
import ModalImageSlider from "components/Carousel/ModalImageSlider"
import ViewCardsSlider from "components/Carousel/ViewCardsSlider"
import { useTranslation } from "react-i18next"
import Card from "./Card"
import moment from "moment"

const calcCommentCount = (list) => {
  let count = list.length
  if (list.length > 5) {
    count = list.length - 4
  }
  return count
}

// let hoverEffect =
//   "object-cover w-full aspect-square hover:scale-110 transition duration-300 ease-in-out"

export default () => {
  const { t } = useTranslation()
  const [cardData, setCardData] = useState({})
  const [loading, setLoading] = useState(true)
  const { id } = useParams()
  const navigate = useNavigate()
  const { showBlured } = useShowModal()
  const { hideModal } = useHideModal()
  const [refresh, setRefresh] = useState(false)
  const currrentLang = localStorage.getItem("lang")

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 })
  }, [])

  useEffect(() => {
    if (id) {
      setLoading(true)
      works
        .getOne(id)
        .then((resp) => {
          // setRateNumber(
          //   resp?.comments?.reduce((acc, comment) => {
          //     return acc + comment.rate
          //   }, 0) / resp?.comments?.length
          // )
          setCardData(() => ({ ...resp }))
        })
        .catch((err) => console.error(err))
        .finally(() => setLoading(false))
    }
  }, [id, refresh])

  const handleCommentRoute = () => {
    navigate(`/works/detail/comments/${id}`)
  }

  const handleImagePreview = (imgIndx, imgData) => {
    showBlured({
      title: "",
      maxWidth: "70vw",
      height: "70vh",
      rounded: "8px",
      button: false,
      overflow: "hidden",
      withHeader: false,
      transparent: true,
      closable: true,
      body: () => (
        <ModalImageSlider
          data={imgData}
          close={hideModal}
          currentImage={imgIndx}
        />
      ),
    })
  }
  const videoPlayerHandler = (videoUrl) => {
    showBlured({
      title: "",
      maxWidth: "70vw",
      maxHeight: "70vh",
      rounded: "8px",
      button: false,
      overflow: "hidden",
      withHeader: false,
      transparent: true,
      closable: true,
      body: () => <VideoPlayerBack url={videoUrl} />,
    })
  }

  if (loading) {
    return <Spinner />
  }
  return (
    <div className="2xl:container w-full h-full flex-1 flex flex-col text-secondary-text-color font-medium font-[Roboto]">
      <div className="flex flex-wrap justify-between align-middle">
        <div className="flex md:w-1/2">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center justify-start gap-1 mr-5 text-base"
          >
            <FiArrowLeft size={20} />
            {t("back")}
          </button>
          <p className="py-5 text-xl font-medium text-primary-text-color">
            {cardData?.group?.title}
          </p>
        </div>
      </div>
      <section className="w-full py-6">
        {Object.keys(cardData).length > 0 ? (
          <>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-4">
              <Card
                data={cardData}
                mediaType="new"
                previewHandler={handleImagePreview}
                title={moment(cardData?.createdAt)
                  .lang(currrentLang)
                  .format("LL")}
                videoPlayerHandler={videoPlayerHandler}
              />
              {cardData?.oldMedia?.length ? (
                <Card
                  data={cardData}
                  mediaType="old"
                  previewHandler={handleImagePreview}
                  title={`${cardData?.workYear}-й`}
                  videoPlayerHandler={videoPlayerHandler}
                />
              ) : (
                ""
              )}
            </div>
            <DescriptionWork className="flex flex-col items-start justify-start gap-2 px-6 mt-12 lg:px-0">
              <h2>{cardData?.title}</h2>
              <div className="flex items-center justify-start w-full">
                <p className="w-full xl:max-w-[85%]">{cardData?.desc}</p>
              </div>
            </DescriptionWork>

            <div className="w-full md:w-[365px] xl:my-10 md:my-8 sm:my-8 mt-8 flex justify-between items-center bg-white px-3 py-2 rounded-2xl">
              {cardData?.comments?.length > 0 && (
                <div className="flex w-6/12 -space-x-4">
                  {cardData?.comments?.map((item, indx) => {
                    return indx === 4 ? (
                      <div
                        key={item?._id}
                        className="z-50 rounded-full w-10 h-10 border-2  bg-[#E7F1F8]  p-2 text-[#1091EF] text-xs font-medium flex justify-center items-center"
                      >
                        {Math.min(
                          calcCommentCount(
                            cardData?.comments?.filter(
                              (item) => item?.comment !== " "
                            )
                          ),
                          99
                        )}
                        +
                      </div>
                    ) : indx < 5 ? (
                      <div
                        key={item?._id}
                        className={`z-${
                          indx + 1
                        }0 relative rounded-full w-10 h-10 border-2 inline object-cover bg-white`}
                      >
                        {item?.photo !== null ? (
                          <img
                            className="w-full h-full rounded-full"
                            src={item?.photo}
                            alt={item?.photo}
                          />
                        ) : (
                          <span className="w-full h-full flex justify-center items-center  p-0.5">
                            <FiUser size={18} />
                          </span>
                        )}
                      </div>
                    ) : null
                  })}
                </div>
              )}
              <div className="w-3/12 flex justify-center items-center gap-1 text-sm font-normal text-[#595F62]">
                <span className="p-0 m-0">
                  {
                    cardData?.comments?.filter((item) => item?.comment !== " ")
                      ?.length
                  }
                </span>
                <span className="p-0 m-0">{t("time-comment")}</span>
              </div>
              <button
                onClick={handleCommentRoute}
                className="rounded-3xl bg-[#E7F1F8] w-24 h-8 p-2 text-[#1091EF] text-base font-medium flex justify-center items-center"
              >
                {t("open-comment")}
              </button>
            </div>
          </>
        ) : (
          <div className="py-20">
            <Empty message="not-found-text" />
          </div>
        )}
        <ViewCardsSlider refresh={refresh} setRefresh={setRefresh} />
      </section>
    </div>
  )
}
